import { memo } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHead,
  TableRow,
} from "@cointervue/design-system/components";

interface TableSkeletonProps {
  columns: number;
  rows?: number;
  showHeader?: boolean;
}

function TableSkeleton({
  columns,
  rows = 5,
  showHeader = true,
}: TableSkeletonProps) {
  return (
    <div className="animate-pulse">
      <Table>
        {showHeader && (
          <TableHeader>
            <TableRow className="hover:bg-transparent">
              {Array.from({ length: columns }).map((_, idx) => (
                <TableHead key={idx}>
                  <div className="h-4 w-24 bg-gray-200 rounded" />
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
        )}

        <TableBody>
          {Array.from({ length: rows }).map((_, rowIdx) => (
            <TableRow key={rowIdx}>
              {Array.from({ length: columns }).map((_, colIdx) => (
                <TableCell key={colIdx}>
                  <div className="h-6 w-full bg-gray-200 rounded" />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}

export default memo(TableSkeleton);
